/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SessionInitData
 */
export interface SessionInitData {
    /**
     * 
     * @type {string}
     * @memberof SessionInitData
     */
    sessionId: string;
    /**
     * 
     * @type {string}
     * @memberof SessionInitData
     */
    composedUrl: string;
    /**
     * 
     * @type {number}
     * @memberof SessionInitData
     */
    resetTimeSec: number;
    /**
     * 
     * @type {string}
     * @memberof SessionInitData
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof SessionInitData
     */
    currencyForAnalytics?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SessionInitData
     */
    currencyIsPrefixed: boolean;
}

export function SessionInitDataFromJSON(json: any): SessionInitData {
    return SessionInitDataFromJSONTyped(json, false);
}

export function SessionInitDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionInitData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
        'composedUrl': json['composedUrl'],
        'resetTimeSec': json['resetTimeSec'],
        'currency': json['currency'],
        'currencyForAnalytics': !exists(json, 'currencyForAnalytics') ? undefined : json['currencyForAnalytics'],
        'currencyIsPrefixed': json['currencyIsPrefixed'],
    };
}

export function SessionInitDataToJSON(value?: SessionInitData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sessionId': value.sessionId,
        'composedUrl': value.composedUrl,
        'resetTimeSec': value.resetTimeSec,
        'currency': value.currency,
        'currencyForAnalytics': value.currencyForAnalytics,
        'currencyIsPrefixed': value.currencyIsPrefixed,
    };
}


